import { ERC20Contract } from 'abi'
import { ethers } from 'ethers'
import tokenSymbol from 'images/erc20-token-placeholder.png'
import { createAlchemyInstance } from 'helpers'
import { TTokenERC20Data } from 'types'

type TGetTokenERC20Data = (
  provider: any,
  tokenAddress: string,
  chainId: number | null
) => Promise<TTokenERC20Data>

const getTokenData: TGetTokenERC20Data = async (provider, tokenAddress, chainId) => {
  try {
    const alchemy = createAlchemyInstance(chainId)
    if (!alchemy) {
      throw new Error('No Alchemy instance is created')
    }
    const tokenData = await alchemy.core.getTokenMetadata(tokenAddress)
    console.log({ tokenData })
    return { symbol: tokenData.symbol || 'ERC20 Token', decimals: tokenData.decimals, description: '', image: tokenData.logo || tokenSymbol } 
  } catch (err) {
    try {
      const contractInstance = new ethers.Contract(tokenAddress, ERC20Contract, provider)
      const symbol = await contractInstance.symbol()
      const decimals = await contractInstance.decimals()
      const image = tokenSymbol
      return {
        symbol,
        decimals,
        description: '',
        image
      }
    } catch (err) {
      // @ts-ignore
      console.log({ err })
      return { symbol: 'ERC20 Token', decimals: 18, description: '', image: tokenSymbol }
    }
  }  
}


export default getTokenData